import React, { AriaAttributes } from 'react';
import * as styles from './List.module.scss';

export type ListProps = {
  component?: 'ol' | 'ul';
  children: React.ReactNode;
  className?: string;
} & AriaAttributes;

export const List = ({
  component = 'ul',
  children,
  className,
  ...ariaProps
}: ListProps) => {
  const classes = [styles.list];

  if (className) classes.push(className);

  return React.createElement(
    component,
    {
      className: classes.join(' '),
      ...ariaProps,
    },
    children
  );
};
